export const LAST_DASHBOARD_TAB_KEY = 'last-dashboard-tab-key'
